import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=6677cb22&scoped=true"
import script from "./activityDetails.vue?vue&type=script&lang=js"
export * from "./activityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677cb22",
  null
  
)

export default component.exports